<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <router-link :to="{ path: '/admin/school/group' }">
          <Button icon="ios-arrow-back" size="small" class="mr20">返回</Button>
        </router-link>
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="userForm" :model="userForm"  :label-width="75" label-position="right" @submit.native.prevent>
        <Row type="flex" :gutter="12">
          <Col>
            <FormItem label="班级名称："  label-for="key">
              <Input search enter-button placeholder="请输入" v-model="userForm.key" @on-search="userSearchs">
              </Input>
            </FormItem>
          </Col>
        </Row>

      </Form>
      <Table :columns="columns2" :data="formInfo" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >
        <template slot-scope="{ row, index }" slot="sort">
          <InputNumber :min="0" v-model="row.sort" @on-blur="OnBlur(row)"/>
        </template>
        <template slot-scope="{ row, index }" slot="status">
          <i-switch v-model="row.status" :value="row.status" :true-value="1" :false-value="0" @on-change="changeSwitch(row)">
          </i-switch>
        </template>


        <template slot-scope="{ row, index }" slot="action">
          <a @click="edit(row.id)">学员列表</a>
          <Divider type="vertical" />
          <a @click="del(row)">删除</a>
        </template>
      </Table>
      <Page :total="dataCount" :current="userForm.page" :page-size="userForm.limit" class="acea-row row-right page" show-total  @on-change="changepage"></Page>
    </Card>
    <!-- 添加编辑-->
<!--    <advertEdit :editShow="editShow" :id="advert_id" :adv_group_id="adv_group_id" @updateStatusModel="updateStatusModel"></advertEdit>-->
    <!--删除-->
<!--    <modalSure ref="modalSure" title="轮播图" :id="advert_id" :modelApi="modelApi" @closeModal="closeModal"></modalSure>-->
  </div>
</template>

<script>
import { classList,classDelete } from '@/api/school'
// import advertEdit from './components/advertEdit'
import modalSure from '@/components/modalSure'
export default {
  name: 'schoolClass',
  components: {  modalSure },
  inject: ['reload'],
  data () {
    return {
      userForm: {
        page: 1,
        limit: 10,
        key: '',
        school_id: 0
      },
      adv_group_id: 0,
      editShow: false,
      // modelApi: delAdv,
      confirm: false,
      dataCount: 0,
      formInfo: [],
      loading: false,
      advert_id: 0,
      ids: 0,
      columns2: [
        {
          title: 'ID',
          key: 'id',
          minWidth: 50
        },
        {
          title: '班级名称',
          key: 'title',
          minWidth: 120
        },
        {
          title: '老师姓名',
          key: 'user_name',
          minWidth: 120
        },

        {
          title: '学生数量',
          key: 'student_num',
          minWidth: 80
        },
        {
          title: 'VIP数量',
          key: 'vip_num',
          minWidth: 80
        },
        {
          title: '书袋数量',
          key: 'bag_num',
          minWidth: 80
        },

        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 120
        }
      ]
    }
  },
  created () {
    if (this.$route.query.school_id >0) {
      this.userForm.school_id = this.$route.query.school_id
      this.advertList()
    }
  },
  methods: {
    advertList () {
      this.loading = true
      classList(this.userForm).then(res => {
        let data = res.data
        this.formInfo = data.list
        this.dataCount = data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changepage (status) {
      this.userForm.page = status
      this.advertList()
    },
    // 表格搜索
    userSearchs () {
      this.userForm.page = 1
      this.advertList()
    },
    selectChange () {
      this.userForm.key = ''
    },
    edit (id) {

      this.$router.push({ path: '/admin/school/user/?class_id=' + id })
    },
    updateStatusModel (modalStatus) {
      this.editShow = modalStatus
      this.reload()
    },
    // 添加
    add () {
      this.editShow = true
    },
    del (row) {
      classDelete({'id':row.id}).then(res => {
        this.$Message.success()

        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    closeModal (val) {
      // if (val) {
        this.reload()
      // }
    },


  }
}
</script>
